import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { authFetch, useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Subscribe() {
    const { user } = useAuth();
    const [packages, setPackages] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        authFetch("get", "/payments/packages").then((r) => setPackages(r.data.packages));
    }, []);

    const checkout = async (packageId) => {
        setLoading(true);
        try {
            const origin_url = window.location.origin;
            const res = await authFetch("post", "/payments/checkout", { package_id: packageId, origin_url });
            window.location.href = res.data.url;
        } catch (err) {
            toast.error(err.response?.data?.detail || "Checkout failed");
            setLoading(false);
        }
    };

    if (user?.subscription_active) {
        return (
            <>
                <Navbar />
                <main className="min-h-screen pt-28 pb-12 px-6">
                    <div className="max-w-xl mx-auto glass-gold p-12 text-center">
                        <p className="label-tracking text-gold">Cosmic Premium · Active</p>
                        <h1 className="font-serif text-5xl mt-3">You are among the stars</h1>
                        <p className="text-muted mt-4">All premium features are unlocked. Expires {new Date(user.subscription_expires).toLocaleDateString()}.</p>
                        <Link to="/dashboard" className="btn-gold-solid inline-block mt-6" data-testid="back-dashboard">Return to Dashboard</Link>
                    </div>
                </main>
            </>
        );
    }

    return (
        <>
            <Navbar />
            <main className="min-h-screen pt-28 pb-12 px-6">
                <div className="max-w-4xl mx-auto">
                    <div className="text-center">
                        <p className="label-tracking text-gold">Cosmic Premium</p>
                        <h1 className="font-serif text-5xl mt-2">Unlock the full sky</h1>
                        <p className="text-muted mt-4 max-w-xl mx-auto font-serif">
                            AI horoscopes for the month and year. Full natal birth charts. Deep synastry readings.
                            The cosmos, unveiled.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
                        {packages.map((p) => (
                            <div key={p.id} className="glass-gold p-8 hover-lift" data-testid={`package-${p.id}`}>
                                <p className="label-tracking text-gold">{p.name}</p>
                                <p className="font-serif text-6xl mt-4 text-gold">
                                    ${p.amount}
                                    <span className="text-base text-muted ml-2">/{p.id.includes("yearly") ? "year" : "month"}</span>
                                </p>
                                <ul className="mt-6 space-y-3 text-sm">
                                    <Bullet>Monthly & Yearly AI horoscopes</Bullet>
                                    <Bullet>Full natal birth chart</Bullet>
                                    <Bullet>AI synastry readings with matches</Bullet>
                                    <Bullet>Priority match algorithm</Bullet>
                                    {p.id === "yearly_premium" && <Bullet gold>Save 33% vs monthly</Bullet>}
                                </ul>
                                <button
                                    onClick={() => checkout(p.id)}
                                    disabled={loading}
                                    className="btn-gold-solid w-full mt-8"
                                    data-testid={`subscribe-${p.id}`}
                                >
                                    {loading ? "Opening..." : "Subscribe"}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
        </>
    );
}

function Bullet({ children, gold }) {
    return (
        <li className={`flex items-start gap-2 ${gold ? "text-gold" : ""}`}>
            <span className="text-gold mt-0.5">✦</span>
            <span>{children}</span>
        </li>
    );
}
